import { render } from "./AssignmentTemplateCompletion.vue?vue&type=template&id=0c26a691"
import script from "./AssignmentTemplateCompletion.vue?vue&type=script&lang=js"
export * from "./AssignmentTemplateCompletion.vue?vue&type=script&lang=js"

import "./AssignmentTemplateCompletion.vue?vue&type=style&index=0&id=0c26a691&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__